import React from 'react';
import { ArrowRight, Trophy, Clock, CheckCircle } from 'lucide-react';

const QuizBanner = () => {
  return (
    <section className="py-10 md:py-16 bg-gradient-to-r from-yellow-500/10 via-orange-500/10 to-yellow-500/10 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-32 md:w-64 h-32 md:h-64 bg-yellow-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-32 md:w-64 h-32 md:h-64 bg-orange-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="glass-dark p-5 sm:p-6 md:p-10 lg:p-12 rounded-2xl md:rounded-3xl border border-yellow-500/30">
            <div className="flex flex-col items-center text-center">
              {/* Logo WING Oficial */}
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_4f5cf654-3a0c-4d01-a704-3b564425efff/artifacts/7rtyg2bx_Logo%20wing%20branca%20png.png"
                  alt="WING Personal Mixing Console"
                  className="h-16 md:h-20 lg:h-24 w-auto"
                />
              </div>

              {/* Content */}
              <div className="w-full">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 md:mb-3">
                  🎯 Teste seu Conhecimento na WING!
                </h2>
                <p className="text-gray-300 text-sm md:text-base mb-4 md:mb-5 max-w-lg mx-auto">
                  Descubra o quanto você sabe sobre a console Behringer WING com nosso quiz gratuito.
                </p>
                
                {/* Features */}
                <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-5 md:mb-6">
                  <div className="flex items-center gap-1.5 text-xs md:text-sm text-gray-400 bg-white/5 px-3 py-1.5 rounded-full">
                    <CheckCircle className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" />
                    <span>10 Perguntas</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs md:text-sm text-gray-400 bg-white/5 px-3 py-1.5 rounded-full">
                    <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-blue-400" />
                    <span>5 minutos</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs md:text-sm text-gray-400 bg-white/5 px-3 py-1.5 rounded-full">
                    <Trophy className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-400" />
                    <span>Resultado imediato</span>
                  </div>
                </div>

                {/* CTA Button */}
                <a
                  href="/quiz"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-black px-6 md:px-8 py-3.5 md:py-4 rounded-xl font-bold text-base md:text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-yellow-500/25 w-full sm:w-auto"
                  data-testid="quiz-banner-btn"
                >
                  FAZER O QUIZ AGORA
                  <ArrowRight className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuizBanner;
